import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator([
  'CREATE_STUDY_ROOM_ERROR',
  'CREATE_STUDY_ROOM_ERROR_SUCCESS',
  'CREATE_STUDY_ROOM_ERROR_FAIL',
]);

export default actionTypes;
